import { render, staticRenderFns } from "./DefaultButtonLink.vue?vue&type=template&id=58c801ba&"
import script from "./DefaultButtonLink.vue?vue&type=script&lang=js&"
export * from "./DefaultButtonLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports